export { BrowserTracing } from './browsertracing';
export { instrumentOutgoingRequests, defaultRequestInstrumentationOptions, } from './request';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/node_modules/@sentry/tracing/esm/browser/index.js
// module id = 388
// module chunks = 81